export default {
  app: {
    privacy: {
      policy: 'Məxfilik siyasəti',
      expansive: 'Expansive istifadə etməklə, Expansive {action}-a razılaşırsınız',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sessiya başa çatdı',
    sessionExpiredDescription:
      'Sessiyanız başa çatdı. Tətbiqdən istifadəni davam etdirmək üçün yenidən daxil olun.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Dili seçin',
      chooseLanguageDescription:
        'Tətbiq üçün istədiyiniz dili seçin. Bu, interfeysin və məzmunun dilini dəyişəcək.',
    },
    userSelection: {
      cancel: 'Ləğv et',
      createNewUser: 'Onların adı siyahıda yoxdur',
      newUser: 'Yeni istifadəçi',
      selectAnExistingUser: 'Mövcud istifadəçini seçin',
      selectUserHint: 'Davam etmək üçün mövcud istifadəçini seçin və ya yenisini yaradın.',
      startTypingToSearch: 'Yazmağa başlayın...',
    },
    verification: {
      codeVerification: {
        continue: 'Davam et',
        header: 'Sayta giriş kodunu daxil edin',
        invalidCode: 'Yanlış kod, yenidən cəhd edin.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Yerləşməni yoxlamadan davam et',
        enterSiteAccessCode: 'Sayta giriş kodunu daxil edin',
        locationNotEnabledOrAvailable: 'Niyə bunu görürəm?',
        notAvailable: {
          description: 'GPS yerləşməsi bu cihazda dəstəklənmir.',
          header: 'Yerləşmə dəstəklənmir',
        },
        notEnabled: {
          description: 'Yerləşmə xidmətləri aktivləşdirilməyib və ya icazə verilməyib.',
          header: 'Yerləşmə aktivləşdirilməyib',
        },
        notVerified: {
          description: 'GPS sizin saytda olmadığınızı göstərir.',
          header: 'Yerləşmə təsdiqlənmədi',
        },
        tryAgain: 'Yenidən cəhd edin',
        unavailable: {
          description: 'GPS yerləşmənizi təsdiqləyə bilmədik.',
          header: 'Yerləşmə mövcud deyil',
        },
        unknown: {
          description: 'Yerləşmənizi müəyyən edə bilmirik.',
          header: 'Yerləşmə naməlumdur',
        },
        verified: {
          description: 'GPS sizin saytda olduğunuzu göstərir.',
          header: 'Yerləşmə təsdiqləndi',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Heç bir aktiv tapılmadı',
        emptyDescription: 'Bu iş orderi ilə əlaqəli heç bir aktiv yoxdur.',
        warrantyParts: 'Ehtiyat hissələrinin zəmanəti bitir',
        serialNumber: 'Seriya nömrəsi',
        none: '<heç biri>',
      },
      updates: {
        emptyTitle: 'Heç bir yenilik tapılmadı',
        emptyDescription: 'Bu iş orderi üçün heç bir yenilik yoxdur.',
        unknownUser: 'Naməlum istifadəçi',
        none: 'Heç biri',
        addComment: {
          buttonLabel: 'Şərh əlavə et',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Təhlükələr',
          no: 'Xeyir',
          yes: 'Bəli',
        },
      },
    },
    attachmentsList: {
      attachments: 'Priloglar',
      documents: 'Sənədlər',
      siteDocuments: 'Sayt sənədləri',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Təhlükələr',
        induction: 'Təlim',
        safeToProceed: 'Davam etmək təhlükəsizdir',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Son tarix',
        activeSessions: 'Aktiv sessiyalar',
        activeSessionsDescription:
          'Siz artıq aşağıdakı iş orderlərinə daxil olmusanız. Yeni bir iş orderinə daxil olmadan əvvəl bu iş orderlərindən çıxmalısınız.',
        resumeSession: 'Davamlama',
        startTime: 'Başlama vaxtı',
        unexpectedErrorTitle: 'Gözlənilməz xəta',
        unexpectedErrorMessage:
          'Sessiyalarınızı yaratmağa çalışarkən gözlənilməz bir xəta baş verdi. Zəhmət olmasa, daha sonra yenidən cəhd edin.',
        engineerNotFound: 'Mühəndis tapılmadı',
        engineerNotFoundDescription:
          'Daxil olmağa çalışdığınız mühəndis sistemdə tapılmadı. Zəhmət olmasa, administratorunuzla əlaqə saxlayın.',
      },
      verification: {
        code: {
          description:
            'Daxil olmaq üçün, zəhmət olmasa, sayt meneceri və ya təyin olunmuş əlaqə şəxsi tərəfindən sizə verilmiş 4-rəqəmli kodu əldə edin.',
        },
        geo: {
          continue: 'Davam et',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Ziyarətinizi tamamlamaq üçün sayt meneceri və ya təyin edilmiş əlaqə nöqtəsindən giriş kodunu əldə edin.',
            checkOut: 'Çıxış et',
            completeBeforeLeaving: 'Zəhmət olmasa, çıxmazdan əvvəl aşağıdakı formu doldurun.',
            continue: 'Davam et',
            noResolutionSelected: 'Zəhmət olmasa, davam etmədən əvvəl bir həll seçin.',
            quoteRequired: {
              hint: 'Ziyarət tamamlandı, qiymət sonra veriləcək',
              label: 'Qiymət tələb olunur',
            },
            returnVisitRequired: {
              hint: 'Tamamlanması üçün yenidən gələcəyik',
              label: 'Təkrar ziyarət tələb olunur',
            },
            serviceCompleted: {
              hint: 'Daha heç bir əməliyyat tələb olunmur',
              label: 'Xidmət tamamlandı',
            },
            uploadCheckout: 'Bir fayl, fotoşəkil və ya video yükləyin',
            visitNotes: 'Ziyarət qeydləri',
            workOrderResolution: 'İş orderinin həlli',
            enterNotes: 'Buraya hər hansı bir qeydi daxil edin...',
            errors: {
              timedOut:
                'Zaman limiti aşdı, 30 saniyədən çox oldu. Zəhmət olmasa, yenidən cəhd edin.',
              closingSession: 'Sessiyanı bağlayarkən xəta',
            },
          },
          success: {
            description:
              'Ziyarət etdiyiniz üçün təşəkkür edirik {site}. | {site} hələ də 1 açıq iş orderinə malikdir. | {site} hələ də {count} açıq iş orderinə malikdir.',
            endVisit: 'Ziyarəti sona çatdır',
            header: 'Uğurla çıxış etdiniz',
            viewWorkOrders: 'Başqa bir iş orderinə daxil olun',
          },
          verification: {
            code: {
              description:
                'Çıxış etmək üçün, zəhmət olmasa, sayt meneceri və ya təyin olunmuş əlaqə şəxsi tərəfindən sizə verilmiş 4-rəqəmli kodu əldə edin.',
              continue: 'Davam et',
            },
            geo: {
              checkOut: 'Çıxış et',
              continue: 'Davam et',
            },
          },
        },
        detail: {
          assets: 'Aktivlər',
          call: 'Zəng et',
          checkOut: 'Çıxış et',
          closed: 'Bağlı',
          details: 'Təfərrüatlar',
          dueBy: 'Son tarix',
          manageEngineers: 'Mühəndisləri idarə et',
          notAvailable: 'Mövcud deyil',
          pointOfContact: 'Əlaqə nöqtəsi',
          siteAccessTimes: 'Sayta giriş vaxtları',
          siteAccessInstructions: 'Giriş təlimatları',
          siteAddress: 'Sayt ünvanı',
          siteNotes: 'Sayt qeydləri',
          siteTelephone: 'Sayt telefonu',
          siteLocation: 'Saytın yerləşməsi',
          updates: 'Yeniliklər',
          more: 'Daha çox',
          mismatchErrorTitle: 'İş orderi xətası',
          mismatchErrorMessage:
            'Giriş etməyə çalışdığınız iş orderi, hal-hazırda daxil olduğunuz iş orderi ilə uyğun gəlmir. Zəhmət olmasa, iş orderinizi yoxlayın və yenidən cəhd edin.',
          siteDocuments: 'Sayt sənədləri',
          validFrom: 'Etibarlıdır',
          validUntil: 'ədək etibarlıdır',
          documentName: 'Sənədin adı',
          documentType: 'Sənədin növü',
          attachments: 'İş orderi faylları',
          download: 'Yüklə',
          workDetails: 'İş təfərrüatları',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Yardımçı mühəndis əlavə et',
            assistantEngineers: 'Yardımçı mühəndislər',
            description:
              'Təhlükəsizlik səbəblərinə görə, zəhmət olmasa, saytda olan hər bir mühəndisin adını qeyd edin.',
            editMainEngineer: 'Əsas mühəndisi redaktə et',
            errors: {
              creatingEngineer: 'Mühəndis yaradarkən xəta',
              creatingSession: 'Sessiya yaradarkən xəta',
            },
            header: 'Saytda olan mühəndislər',
            mainEngineer: 'Əsas mühəndis',
            newAssistantEngineer: 'Tam adını daxil et',
            next: 'Sonrakı',
            removeEngineer: 'Mühəndisi sil',
            selectExistingAssistantEngineer: 'Adını yazmağa başlayın',
          },
          index: {
            description:
              'Təhlükəsizlik səbəblərinə görə, zəhmət olmasa, saytda olan hər bir mühəndisin adını qeyd edin.',
            errorCreatingEngineer: 'Mühəndis yaradarkən xəta, zəhmət olmasa, yenidən cəhd edin.',
            header: 'Saytda olan mühəndislər',
            hintMainEngineer: 'Əsas mühəndisin tam adını daxil edin',
            newMainEngineer: 'Yeni əsas mühəndis',
            next: 'Sonrakı',
            selectExistingMainEngineer: 'Mövcud əsas mühəndisi seçin',
            yes: 'Bəli',
            no: 'Xeyir',
            mainEngineerLabel: 'Siz əsas mühəndis misiniz?',
          },
        },
        index: {
          callUsOn: 'Bizə zəng edin {phoneNumber}',
          description: 'Axtardığınızı tapa bilmirsiniz?',
          dueBy: 'Son tarix',
          header: 'İş orderini seçin',
          notAvailable: 'Mövcud deyil',
          searchWorkOrders: 'İş orderlərini axtarın...',
        },
        manageEngineers: {
          manageEngineers: 'Mühəndisləri idarə et',
          notWorking: 'Aktiv olmayan işçilər',
          pause: 'Dayandır',
          resume: 'Davamlama',
          workingNow: 'Aktiv işçilər',
          startTime: 'Başlama vaxtı',
          endTime: 'Bitmə vaxtı',
          duration: 'Müddət',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Geri bildirim',
            feedbackDescription:
              'Xidmətlərimizi inkişaf etdirmək üçün iş orderi haqqında geri bildirim verin.',
            feedbackLabel: 'Geri bildirim',
            filesLabel: 'Priloglar',
            submissionLabel: 'Geri bildirimi göndərin',
          },
          hazards: {
            back: 'Geri dön',
            hazards: 'Təhlükələr',
            next: 'Sonrakı',
            no: 'Xeyir',
            noTasksForHazard: 'Bu təhlükə üçün tamamlanacaq heç bir vəzifə yoxdur.',
            yes: 'Bəli',
          },
          induction: {
            continue: 'Davam et',
            induction: 'Təlim',
          },
          index: {
            checkIn: 'Daxil ol',
            description:
              'Seçilmiş iş üçün zəhmət olmasa, aşağıdakı risk qiymətləndirməsini tamamlayın.',
            fail: 'İş orderi yoxlamalarını başlamaqda uğursuz oldu.',
            haltMessage:
              'Potensial risklər aşkar edildi. Zəhmət olmasa, işi dayandırın, təhlükəsizlik qaydalarını nəzərdən keçirin və əlavə təlimatlar üçün müdirinizlə əlaqə saxlayın.',
            header: 'İşə başlama yoxlamaları',
            endVisit: 'Ziyarəti sona çatdır',
            leaveFeedback: 'Geri bildirim bırak',
          },
          safeToProceed: {
            continue: 'Davam et',
            safeToProceed: 'Davam etmək təhlükəsizdir',
          },
        },
      },
    },
    index: {
      title: 'Xoş gəlmisiniz',
      description: 'Başlamaq üçün yerinizdəki QR kodunu skan edin.',
    },
    login: {
      errorTitle: 'Gözlənilməz xəta',
      errorMessage: 'Gözlənilməz bir xəta baş verdi. Zəhmət olmasa, yenidən QR kodunu skan edin.',
    },
    unauthenticated: {
      welcome: {
        title: '{site} saytına xoş gəlmisiniz',
        description:
          'Sizə hər hansı bir iş orderi göstərə bilmədən əvvəl, məlumatlarınızı təsdiqləməliyik. Davam etmək üçün aşağıdakı düyməni klikləyin.',
        next: 'Davam et',
      },
      index: {
        errorTitle: 'Gözlənilməz xəta',
        errorMessage: 'Gözlənilməz bir xəta baş verdi. Zəhmət olmasa, yenidən QR kodunu skan edin.',
      },
      contractor: {
        title: 'Harada işləyirsiniz?',
        contractor: 'Podratçı',
        contractorLabel: 'Şirkət adınızı yazmağa başlayın',
        contractorHint: 'Nəticələri görmək üçün 3 və ya daha çox simvol daxil etməlisiniz',
        defaultSelectPlaceholder: '--Zəhmət olmasa seçin--',
        next: 'Sonrakı',
      },
      user: {
        title: 'Siz kimsiniz?',
        cancel: 'Ləğv et',
        createNewUserLabel: 'Adım siyahıda yoxdur',
        existingUserLabel: 'Adınızı yazmağa başlayın',
        existingUserHint: 'Nəticələri görmək üçün 3 və ya daha çox simvol daxil etməlisiniz',
        newUserLabel: 'Tam adınızı daxil edin',
        next: 'Sonrakı',
        user: 'İstifadəçi',
      },
      verification: {
        methods: {
          add: {
            add: 'Təsdiq metodunu əlavə et',
            defaultSelectPlaceholder: '--Zəhmət olmasa seçin--',
            emailLabel: 'Email',
            existingMethodWarning:
              'Artıq bu təsdiq metodu üçün gözləyən bir tələbınız var. Yeni birini əlavə etmək, onu üstələyəcək.',
            method: 'Metod',
            methodLabel: 'Metod',
            mobileCountryHint: 'Zəhmət olmasa, ölkə kodunuzu seçin',
            mobileCountryLabel: 'Mobil ölkə kodu',
            mobileHint: 'Zəhmət olmasa, mobil nömrənizi daxil edin',
            mobileLabel: 'Mobil',
            title: 'Təsdiq metodunu əlavə et',
          },
          confirm: {
            confirm: 'Təsdiq et',
            description: 'Davamlamaq üçün zəhmət olmasa təsdiq metodunuzu təsdiqləyin.',
            label: 'Kodu daxil edin',
            resend: 'Yenidən göndər',
            resendPrompt: 'Kodu almırsınız?',
            title: 'Təsdiq Metodunu Təsdiqləyin',
          },
          confirmed: {
            description:
              'Bu təsdiq metodunun administratorunuz tərəfindən təsdiqləndikdə sizə bildiriləcək, sonra onu şəxsiyyətinizi təsdiqləmək üçün istifadə etməyə başlaya bilərsiniz.',
            forceApproval: 'Təsdiqlənənə qədər, iş orderlərinə daxil ola bilmirsiniz.',
            nonForceApproval: 'Bu arada, iş orderlərinə məhdud giriş ilə davam edə bilərsiniz.',
            nonForceApprovalButtonLabel: 'Məhdud giriş ilə davam et',
            title: 'Təsdiqlənməyi gözləyir',
          },
          addNew: 'Yeni təsdiq metodu əlavə et',
          description:
            'Sizin şəxsiyyətinizi təsdiqləmək üçün iş orderinə tam giriş vermək üçün təsdiqləmək lazımdır.',
          email: 'Email',
          hint: 'Seçdiyiniz təsdiq metoduna bir bağlantı göndərəcəyik, bu da sizə iş orderinə tam giriş verəcək. Əgər hər hansı bir mövcud təsdiq metodunu dəyişdirmək lazımdırsa, zəhmət olmasa, administratorunuzla əlaqə saxlayın.',
          label: 'Təsdiq metodunu seçin',
          next: 'Sonrakı',
          pendingHint: 'Administratorunuzdan təsdiq gözlənilir',
          sms: 'SMS',
          title: 'Təsdiq',
        },
        optional: {
          hint: 'İstifadəçi məlumatlarınızı təsdiqləmək, sizə iş orderinə tam giriş verəcək',
          label: 'İstifadəçi məlumatlarınızı təsdiqləmək istəyirsinizmi?',
          next: 'Sonrakı',
          no: 'Xeyir',
          noHint:
            'İstifadəçi məlumatlarımı təsdiqləmək istəmirəm və iş orderinə məhdud giriş ilə davam etmək istəyirəm',
          title: 'Təsdiq',
          yes: 'Bəli',
          yesHint:
            'İstifadəçi məlumatlarımı təsdiqləmək istəyirəm və iş orderinə tam giriş əldə etmək istəyirəm',
        },
        sent: {
          description:
            '{identifier} ünvanına bir giriş bağlantısı göndərilmişdir. Zəhmət olmasa, girişinizi tamamlamaq üçün bağlantıya klikləyin.',
          title: 'Giriş bağlantısı göndərildi',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Dünən',
      today: 'Bugün',
      days: {
        monday: 'Bazar ertəsi',
        tuesday: 'Çərşənbə axşamı',
        wednesday: 'Çərşənbə',
        thursday: 'Cümə axşamı',
        friday: 'Cümə',
        saturday: 'Şənbə',
        sunday: 'Bazar',
      },
      months: {
        january: 'Yanvar',
        february: 'Fevral',
        march: 'Mart',
        april: 'Aprel',
        may: 'May',
        june: 'İyun',
        july: 'İyul',
        august: 'Avqust',
        september: 'Sentyabr',
        october: 'Oktyabr',
        november: 'Noyabr',
        december: 'Dekabr',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Bir şey səhv getdi',
      message: 'Zəhmət olmasa, yenidən QR kodunu skan edin.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Naməlum istifadəçi',
      },
      none: 'Heç biri',
      types: {
        stateTransition: 'Status dəyişdi',
        contractorAssigned: 'Podratçı təyin edildi',
        engineerAssigned: 'Mühəndis təyin edildi',
        serviceAssigned: 'Xidmət təyin edildi',
        priorityChanged: 'Prioritet dəyişdi',
        actionableDateChanged: 'İcra tarixi dəyişdi',
        dueDateChanged: 'Son tarix dəyişdi',
        etaDateChanged: 'Təxmin edilən gəlmə tarixi dəyişdi',
        spendLimitApproved: 'Xərc limiti təsdiq edildi',
        spendLimitCancelled: 'Xərc limiti tələbi ləğv edildi',
        spendLimitRejected: 'Xərc limiti rədd edildi',
        spendLimitRequested: 'Xərc limiti tələb edildi',
        jobSheetUploaded: 'İş vərəqi yükləndi',
        slaAlertSent: 'Zamanla müdaxilə edilmiş SLA xəbərdarlığı',
        issuedWorkPermit: 'İş icazəsi verildi',
        requestForServiceSent: 'Xidmət tələbi göndərildi',
        comment: 'Şərh əlavə edildi',
        unknown: 'Naməlum hadisə',
      },
      labels: {
        actionableDate: 'İcra tarixi',
        comment: 'Şərh',
        file: 'Fayl',
        contractor: 'Podratçı',
        dueDate: 'Son tarix',
        etaDate: 'Təxmin edilən gəlmə tarixi',
        engineer: 'Mühəndis',
        priority: 'Prioritet',
        requestForService: 'Xidmət tələbi',
        service: 'Xidmət',
        spendLimit: 'Xərc limiti',
        status: 'Status',
        workPermit: 'İş icazəsi',
      },
    },
  },
}
